/**
 * Theme switcher component.
 * Note: Theme switching is now handled by ModeDropdown in the navbar.
 * This component is kept for backward compatibility but delegates to ModeDropdown.
 * Based on Vuexy theme switching, now uses settingsStore instead of themeStore.
 */

// MUI Imports
import { IconButton } from '@mui/material';
import { Brightness4, Brightness7 } from '@mui/icons-material';

// Hook Imports
import { useSettings } from '@core/hooks/useSettings';

/**
 * Theme switcher component that toggles between light and dark modes.
 * Uses the settings store for theme management.
 * Note: This is a simplified version. For full theme switching (light/dark/system),
 * use the ModeDropdown component in the navbar.
 */
export const ThemeSwitcher = () => {
  // Hooks
  const { settings, updateSettings } = useSettings();

  // Toggle between light and dark (simplified - ModeDropdown supports system mode)
  const handleToggle = () => {
    const newMode = settings.mode === 'dark' ? 'light' : 'dark';
    updateSettings({ mode: newMode });
  };

  const isDark = settings.mode === 'dark';

  return (
    <IconButton onClick={handleToggle} color="inherit" aria-label="Toggle theme">
      {isDark ? <Brightness7 /> : <Brightness4 />}
    </IconButton>
  );
};
